var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Loader } from "@googlemaps/js-api-loader";
import { MarkerClusterer } from "@googlemaps/markerclusterer";
import { decodeHtmlEntities } from "../../assets/js/helpers/utils";
var AllLocationsMap = /** @class */ (function () {
    function AllLocationsMap(element) {
        var _this = this;
        this.defaultIdPattern = 'all-locations-map-block_';
        this.decodeHtmlEntities = decodeHtmlEntities;
        this.mapBlock = element;
        this.mapBlockId = this.mapBlock.id;
        this.searchContainer = this.mapBlock.querySelector('[data-search-input]');
        this.searchInput = this.searchContainer.querySelector('input');
        this.searchSubmitButton = this.searchContainer.querySelector('button');
        this.locationTypes = this.mapBlock.querySelectorAll('[data-location-type]');
        this.resultsContainer = this.mapBlock.querySelector('.country-list');
        this.countryListSelectContainer = this.mapBlock.querySelector('.country-list-select');
        this.countrySelect = this.countryListSelectContainer.querySelector('select');
        this.countryListItems = this.resultsContainer.querySelectorAll('.country-list-item');
        this.body = document.querySelector('body');
        this.pageOverlay = document.querySelector('[data-page-overlay]');
        this.pageLoader = document.querySelector('[data-page-loader]');
        this.mapContainer = this.mapBlock.querySelector('.map');
        this.countries = this.resultsContainer.querySelectorAll('.country-list-item:not(.all)');
        var clusterSvg = window.btoa("\n                <svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 56 56\" fill=\"none\">\n                <circle cx=\"28\" cy=\"28\" r=\"20\" fill=\"#F26A21\"/>\n                <circle cx=\"28\" cy=\"28\" r=\"24\" stroke=\"#fff\" stroke-opacity=\".8\" stroke-width=\"8\"/>\n                </svg>");
        this.markerClusterRenderer = {
            render: function (_a) {
                var count = _a.count, position = _a.position;
                return new google.maps.Marker({
                    label: { text: String(count), color: "white", fontSize: "14px", fontWeight: "600" },
                    icon: {
                        url: "data:image/svg+xml;base64,".concat(clusterSvg),
                        scaledSize: new google.maps.Size(56, 56),
                    },
                    position: position,
                    // adjust zIndex to be above other markers
                    zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count,
                });
            }
        };
        this.mapCountriesData = [];
        this.mapMarkers = [];
        this.mapStyles = [
            {
                "featureType": "all",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "weight": "2.00"
                    }
                ]
            },
            {
                "featureType": "all",
                "elementType": "geometry.stroke",
                "stylers": [
                    {
                        "color": "#9e9e9e"
                    }
                ]
            },
            {
                "featureType": "all",
                "elementType": "labels.text",
                "stylers": [
                    {
                        "visibility": "on"
                    }
                ]
            },
            {
                "featureType": "administrative.country",
                "elementType": "labels.text",
                "stylers": [
                    {
                        "visibility": "on"
                    },
                    {
                        "color": "#616161"
                    },
                    {
                        "weight": "0.01"
                    }
                ]
            },
            {
                "featureType": "administrative.province",
                "elementType": "geometry.stroke",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "administrative.province",
                "elementType": "labels",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "administrative.locality",
                "elementType": "labels",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "administrative.neighborhood",
                "elementType": "labels",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "administrative.land_parcel",
                "elementType": "labels",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "landscape",
                "elementType": "all",
                "stylers": [
                    {
                        "color": "#f2f2f2"
                    }
                ]
            },
            {
                "featureType": "landscape",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "color": "#ffffff"
                    }
                ]
            },
            {
                "featureType": "landscape",
                "elementType": "labels",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "landscape.man_made",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "color": "#ffffff"
                    }
                ]
            },
            {
                "featureType": "landscape.man_made",
                "elementType": "labels",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "landscape.natural",
                "elementType": "labels",
                "stylers": [
                    {
                        "visibility": "on"
                    },
                    {
                        "color": "#ff0000"
                    }
                ]
            },
            {
                "featureType": "landscape.natural",
                "elementType": "labels.text",
                "stylers": [
                    {
                        "visibility": "on"
                    },
                    {
                        "color": "#616161"
                    },
                    {
                        "weight": "0.01"
                    }
                ]
            },
            {
                "featureType": "landscape.natural.landcover",
                "elementType": "labels.text",
                "stylers": [
                    {
                        "visibility": "off"
                    },
                    {
                        "color": "#616161"
                    }
                ]
            },
            {
                "featureType": "poi",
                "elementType": "all",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "poi",
                "elementType": "labels",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "road",
                "elementType": "all",
                "stylers": [
                    {
                        "saturation": -100
                    },
                    {
                        "lightness": 45
                    }
                ]
            },
            {
                "featureType": "road",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "color": "#eeeeee"
                    }
                ]
            },
            {
                "featureType": "road",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#7b7b7b"
                    }
                ]
            },
            {
                "featureType": "road",
                "elementType": "labels.text.stroke",
                "stylers": [
                    {
                        "color": "#ffffff"
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "all",
                "stylers": [
                    {
                        "visibility": "on"
                    },
                    {
                        "color": "#dadada"
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "labels.icon",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "road.arterial",
                "elementType": "all",
                "stylers": [
                    {
                        "visibility": "on"
                    },
                    {
                        "color": "#e8e8e8"
                    }
                ]
            },
            {
                "featureType": "road.arterial",
                "elementType": "labels.icon",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "road.local",
                "elementType": "all",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "road.local",
                "elementType": "labels",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "transit",
                "elementType": "all",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "all",
                "stylers": [
                    {
                        "color": "#46bcec"
                    },
                    {
                        "visibility": "on"
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "color": "#b1c8d2"
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "labels.text",
                "stylers": [
                    {
                        "visibility": "simplified"
                    },
                    {
                        "color": "#e22121"
                    },
                    {
                        "weight": "0.01"
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#616161"
                    },
                    {
                        "visibility": "on"
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "labels.text.stroke",
                "stylers": [
                    {
                        "color": "#ffffff"
                    }
                ]
            }
        ];
        this.wordpressApiLink = "".concat(window.location.protocol, "//").concat(window.location.hostname, "/wp-admin/admin-ajax.php?action=map_locations_filter");
        this.typingTimeout = null;
        this.appliedSearchFilter = {};
        this.mapsLoader = new Loader({
            apiKey: "AIzaSyDBa4C7O9vX_tV_mixTW3_fXSR976LeoXg",
        });
        if (!this.mapBlockId.includes(this.defaultIdPattern)) {
            // wait for page to load
            window.addEventListener('load', function () { return _this.checkBodyClass().then(function (r) { return _this.urlCheck(); }); });
        }
        else {
            this.init(false);
        }
    }
    // check for body to not contain no-scroll class
    AllLocationsMap.prototype.checkBodyClass = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!document.body.classList.contains('no-scroll')) return [3 /*break*/, 2];
                        return [4 /*yield*/, new Promise(function (resolve) { return setTimeout(resolve, 100); })];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 0];
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    AllLocationsMap.prototype.urlCheck = function () {
        var _this = this;
        // if block has unique id set
        var hash = window.location.hash;
        // if page has hash and hash includes block id
        if (hash && hash.includes(this.mapBlockId)) {
            var cleanedHash = decodeURIComponent(hash.replace("#".concat(this.mapBlockId, "-"), ''));
            var _a = cleanedHash.split('-'), locationType = _a[0], locationCountry = _a[1];
            this.activeLocationType = locationType;
            // Set active location type based on url hash
            this.mapBlock.querySelectorAll('[data-location-type]').forEach(function (locationType) {
                if (locationType.dataset.locationType === _this.activeLocationType) {
                    locationType.classList.add('active');
                }
                else {
                    locationType.classList.remove('active');
                }
            });
            this.init(true);
            this.setFilter('loc_type', this.activeLocationType);
            this.mapBlock.scrollIntoView({ behavior: 'smooth' });
        }
        else {
            this.init(false);
        }
    };
    AllLocationsMap.prototype.init = function (hasUrlHash) {
        var _this = this;
        this.mapsLoader.load().then(function () { return __awaiter(_this, void 0, void 0, function () {
            var Map, hash, cleanedHash, _a, locationType, locationCountry;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.mapBlock.classList.remove('loading');
                        return [4 /*yield*/, google.maps.importLibrary("maps")];
                    case 1:
                        Map = (_b.sent()).Map;
                        this.googleMap = new Map(this.mapContainer, {
                            center: { lat: -34.397, lng: 150.644 },
                            zoom: 8,
                            mapId: 'c7cf9227d1835981',
                            disableDefaultUI: true,
                        });
                        hash = window.location.hash;
                        cleanedHash = decodeURIComponent(hash.replace("#".concat(this.mapBlockId, "-"), ''));
                        _a = cleanedHash.split('-'), locationType = _a[0], locationCountry = _a[1];
                        if (!hasUrlHash) {
                            this.activeCountry = { name: this.countries[0].dataset.countryName, id: this.countries[0].dataset.countryId };
                        }
                        else if (hasUrlHash && locationCountry === undefined) {
                            this.activeCountry = { name: 'all', id: 'all' };
                        }
                        //await this.initializeMap(); // Reset map location & markers
                        this.loadMarkersApiData(true);
                        return [2 /*return*/];
                }
            });
        }); });
        // Set initial type on load
        // if no url hash is set - set first location type as active
        if (!hasUrlHash) {
            var initialActiveType = this.mapBlock.querySelector('.active[data-location-type]');
            this.activeLocationType = initialActiveType.dataset.locationType;
        }
        this.appliedSearchFilter['loc_type'] = this.activeLocationType;
        this.addEventListeners();
    };
    AllLocationsMap.prototype.addEventListeners = function () {
        var _this = this;
        // Add event listeners
        this.searchInput.addEventListener('keyup', this.searchListener.bind(this));
        this.searchSubmitButton.addEventListener('click', this.searchListener.bind(this));
        this.locationTypes.forEach(function (locationType) { return locationType.addEventListener('click', _this.locationTypeListener.bind(_this)); });
        this.countryListToggleListener(false);
    };
    AllLocationsMap.prototype.countryListToggleListener = function (reset) {
        var _this = this;
        if (reset) {
            // If reset true - remove event listeners from old elements
            this.countryListItems.forEach(function (countryListItem) {
                countryListItem.removeEventListener('click', _this.countryListItemListener.bind(_this));
            });
            this.countrySelect.removeEventListener('change', function (event) {
                var currentItem = event.currentTarget;
                var countryId = currentItem.value;
                var countryListItem = _this.resultsContainer.querySelector('.country-list-item[data-country-id="' + countryId + '"]');
                // If clicked - show all: show all markers, else load specific country
                _this.activeCountry = { name: countryListItem.dataset.countryName, id: countryId };
                _this.setClickedCountryMapPosition().then(function (r) { });
            });
        }
        this.countrySelect = this.countryListSelectContainer.querySelector('select');
        this.countryListItems = this.resultsContainer.querySelectorAll('.country-list-item');
        this.countrySelect.addEventListener('change', function (event) {
            var currentItem = event.currentTarget;
            var countryId = currentItem.value;
            var countryListItem = _this.resultsContainer.querySelector('.country-list-item[data-country-id="' + countryId + '"]');
            // If clicked - show all: show all markers, else load specific country
            _this.activeCountry = { name: countryListItem.dataset.countryName, id: countryId };
            _this.setClickedCountryMapPosition().then(function (r) { });
        });
        this.countryListItems.forEach(function (countryListItem) {
            countryListItem.addEventListener('click', _this.countryListItemListener.bind(_this));
        });
    };
    AllLocationsMap.prototype.countryListItemListener = function (event) {
        // Country list item listener
        var countryListItem = event.currentTarget;
        // If clicked - show all: show all markers, else load specific country
        this.activeCountry = { name: countryListItem.dataset.countryName, id: countryListItem.dataset.countryId };
        this.setClickedCountryMapPosition().then(function (r) { });
    };
    AllLocationsMap.prototype.searchListener = function (event) {
        var _this = this;
        clearTimeout(this.typingTimeout);
        // Get the search query from the input
        this.searchQuery = this.searchInput.value;
        // Check if the user pressed the Enter key (key code 13)
        // @ts-ignore
        if (event.keyCode === 13) {
            // Perform the search or any other action here
            this.setFilter('term', this.searchQuery);
        }
        else {
            // Set a timeout to perform an action after the delimiter delay - set filter search parameters
            this.typingTimeout = setTimeout(function () { return _this.setFilter('term', _this.searchQuery); }, 1000);
        }
    };
    AllLocationsMap.prototype.locationTypeListener = function (event) {
        // Set active filters on click
        var type = event.currentTarget;
        var isActive = type.classList.contains('active');
        var typeValue = type.dataset.locationType;
        this.activeLocationType = typeValue;
        var typesContainer = type.parentElement;
        var hash = window.location.hash;
        // if page has hash and hash includes block id
        if (hash && hash.includes(this.mapBlockId)) {
            window.location.hash = '';
        }
        if (!isActive) {
            var activeElements = typesContainer.querySelectorAll('.active');
            activeElements.forEach(function (element) { return element.classList.remove('active'); });
            type.classList.add('active');
            this.setFilter('loc_type', typeValue);
        }
    };
    AllLocationsMap.prototype.setFilter = function (type, value) {
        // Clear map markers on any filter change or search
        if (this.mapMarkers.length > 0) {
            this.mapMarkers.forEach(function (markrItem) {
                markrItem.setMap(null); // Remove country marker from map
            });
            this.googleMap.Marker = []; // clear
            this.mapMarkers = []; // clear
            this.markerCluster.clearMarkers();
        }
        // Set filter values and type based on clicked value
        if (this.appliedSearchFilter.hasOwnProperty(type) && type !== 'term') {
            // Check if appliedFilter already exist such filter type
            var filterArray = this.appliedSearchFilter[type];
            if (value === 'all') {
                // if clicked show all - delete filter type
                delete this.appliedSearchFilter[type];
            }
            else {
                // If filter value doesn't exist, add it to the filterArray
                this.appliedSearchFilter[type] = value;
            }
        }
        else if (type === 'term' && value !== '') {
            // If filter type is search - update filter value
            this.appliedSearchFilter[type] = value;
        }
        else if (type === 'term' && value == '') {
            delete this.appliedSearchFilter[type];
        }
        else if (!this.appliedSearchFilter.hasOwnProperty(type) && value !== 'all') {
            // If filterType doesn't exist, create a new entry with an array containing filterValue
            this.appliedSearchFilter[type] = value;
        }
        this.loadApiResults();
    };
    AllLocationsMap.prototype.setClickedCountryMapPosition = function () {
        return __awaiter(this, void 0, void 0, function () {
            var selectedCountryIndex, bounds, showAllToggle, clickedLocation;
            var _this = this;
            return __generator(this, function (_a) {
                selectedCountryIndex = this.searchResults.data.findIndex(function (countryObj) { return countryObj.country === _this.activeCountry['name']; });
                bounds = new google.maps.LatLngBounds();
                showAllToggle = this.mapBlock.querySelector('.country-list-item.all');
                if (this.activeCountry['id'] === 'all') {
                    showAllToggle.classList.add('active');
                }
                // Set url hash if country clicked & remove if clicked to show all
                if (!this.mapBlockId.includes(this.defaultIdPattern) && this.activeCountry['id'] !== 'all') {
                    window.location.hash = "#".concat(this.mapBlockId, "-").concat(this.activeLocationType, "-").concat(this.activeCountry['id']);
                }
                else if (!this.mapBlockId.includes(this.defaultIdPattern) && this.activeCountry['id'] === 'all') {
                    window.location.hash = '';
                }
                this.countryListItems.forEach(function (countryListItem) {
                    // Loop each country list item and remove active class
                    countryListItem.classList.remove('active');
                    if (countryListItem.dataset.countryId === _this.activeCountry['id']) {
                        // If country list item matches active country, add active class
                        countryListItem.classList.add('active');
                    }
                });
                if (this.activeCountry['id'] === 'all') {
                    this.searchResults['data'].forEach(function (country) {
                        // Loop each api result item
                        country['items'].forEach(function (location) {
                            bounds.extend({ lat: location['location']['lat'], lng: location['location']['lng'] }); // Extend boundaries with markers
                        });
                    });
                }
                else {
                    this.searchResults['data'][selectedCountryIndex]['items'].forEach(function (location) {
                        // Loop each api result item
                        // Custom marker content
                        bounds.extend({ lat: location['location']['lat'], lng: location['location']['lng'] }); // Extend boundaries with markers
                    });
                    clickedLocation = this.searchResults['data'][selectedCountryIndex]['items'][0]['location'];
                    this.googleMap.panTo({ lat: clickedLocation.lat, lng: clickedLocation.lng });
                }
                this.googleMap.maxDefaultZoom = 10;
                this.googleMap.fitBounds(bounds); // Fit map to bound all markers
                google.maps.event.addListenerOnce(this.googleMap, "bounds_changed", function () {
                    this.setZoom(Math.min(this.getZoom(), this.maxDefaultZoom));
                });
                return [2 /*return*/];
            });
        });
    };
    AllLocationsMap.prototype.setAllCountryMapPosition = function () {
        return __awaiter(this, void 0, void 0, function () {
            var AdvancedMarkerElement, bounds, uniqueItemsMap, cleanedCountriesArray;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // Set all country markers on map
                        this.mapMarkers.forEach(function (markrItem) {
                            markrItem.setMap(null); // Remove country marker from map
                        });
                        this.googleMap.Marker = []; // clear
                        this.mapMarkers = []; // clear
                        this.mapMarkers = []; // clear
                        return [4 /*yield*/, google.maps.importLibrary("marker")];
                    case 1:
                        AdvancedMarkerElement = (_a.sent()).AdvancedMarkerElement;
                        bounds = new google.maps.LatLngBounds();
                        uniqueItemsMap = {};
                        cleanedCountriesArray = this.searchResults['data'].map(function (countryObj) {
                            // Check if the "items" array is present and is an array
                            if (Array.isArray(countryObj.items)) {
                                // Filter out duplicates based on the "id" property
                                var uniqueItems = countryObj.items.filter(function (item) {
                                    if (!uniqueItemsMap[item.id]) {
                                        // If the item is not seen before, mark it as seen
                                        uniqueItemsMap[item.id] = true;
                                        return true;
                                    }
                                    return false;
                                });
                                // Update the "items" array with unique items
                                return __assign(__assign({}, countryObj), { items: uniqueItems });
                            }
                            // If "items" array is not present or not an array, return the original object
                            return countryObj;
                        });
                        this.searchResults['data'] = cleanedCountriesArray;
                        // Iterate through the countries array
                        cleanedCountriesArray.forEach(function (country) {
                            country['items'].forEach(function (location) {
                                // Loop each api result item
                                // Custom marker content
                                var itemMarker = document.createElement('div');
                                if (location['locationIcon'] === null) {
                                    itemMarker.className = 'item-marker icon color-reset';
                                    itemMarker.textContent = '';
                                }
                                else {
                                    itemMarker.className = 'item-marker color-reset';
                                    itemMarker.innerHTML = '<img src="' + location['locationIcon'] + '" alt="' + location['title'] + '">';
                                }
                                itemMarker.setAttribute('data-item-id', location.id);
                                // Set marker with custom content
                                var marker = new AdvancedMarkerElement({
                                    title: _this.decodeHtmlEntities(location['title']),
                                    map: _this.googleMap,
                                    position: { lat: location['location']['lat'], lng: location['location']['lng'] },
                                    content: itemMarker,
                                });
                                bounds.extend({ lat: location['location']['lat'], lng: location['location']['lng'] }); // Extend boundaries with markers
                                // Set location window content
                                var infoWindowContent = document.createElement('div');
                                infoWindowContent.className = 'info-window-content';
                                infoWindowContent.innerHTML = '<h4 class="color-reset">' + location['title'] + '</h4>';
                                infoWindowContent.innerHTML += '<p class="color-reset">' + location['address'] + '</p>';
                                if (location['phoneNumber'] !== '' && location['phoneNumber'] !== null) {
                                    // If phone number not empty
                                    infoWindowContent.innerHTML += '<a class="color-reset" href="tel:' + location['phoneNumber'] + '">' + location['phoneNumber'] + '</a>';
                                }
                                if (location['email'] !== '' && location['email'] !== null) {
                                    // If email not empty
                                    infoWindowContent.innerHTML += '<a class="color-reset" href="mailto:' + location['email'] + '">' + location['email'] + '</a>';
                                }
                                if (location['workingHours']['type'] !== 'no-hours') {
                                    if (location['workingHours']['type'] === '247') {
                                        // If working hours type is 24/7
                                        infoWindowContent.innerHTML += '<p class="color-reset">' + location['workingHours']['translation'] + '</p>';
                                    }
                                    else if (location['workingHours']['type'] === 'same') {
                                        // If same for all days
                                        infoWindowContent.innerHTML += '<p class="color-reset">' + location['workingHours']['translation']
                                            + ': ' + location['workingHours']['openFrom'] + ' - ' + location['workingHours']['openTill'] + '</p>';
                                    }
                                    else if (location['workingHours']['type'] === 'same-custom') {
                                        // If specific work time for specific days & dates
                                        var workingHtml = '<ul>';
                                        workingHtml += '<li>';
                                        workingHtml += location['workingHours']['translation'];
                                        workingHtml += '</li>';
                                        workingHtml += '</ul>';
                                        infoWindowContent.innerHTML += workingHtml;
                                    }
                                    else if (location['workingHours']['type'] === 'specifiedDays') {
                                        // If specific work time for specific days & dates
                                        var workingHtml_1 = '<ul>';
                                        location['workingHours']['dayList'].forEach(function (day) {
                                            workingHtml_1 += '<li>';
                                            workingHtml_1 += day['dayTranslation'] + ': ';
                                            if (day['status'] === false) {
                                                workingHtml_1 += day['closedText'];
                                            }
                                            else {
                                                workingHtml_1 += day['openFrom'] + ' - ' + day['openTill'];
                                            }
                                            workingHtml_1 += '</li>';
                                        });
                                        workingHtml_1 += '</ul>';
                                        infoWindowContent.innerHTML += workingHtml_1;
                                    }
                                }
                                marker.addListener("click", function () {
                                    // Create new info window & content
                                    if (_this.mapInfoWindow && _this.mapPreviousActiveMarker === marker.title) {
                                        // If there is mapInfoWindow and previousActiveMarker is the same as current marker
                                        // Clicking same marker again - close info window
                                        _this.mapInfoWindow.close();
                                        _this.mapInfoWindow = null;
                                        _this.mapPreviousActiveMarker = null;
                                    }
                                    else if (_this.mapInfoWindow && _this.mapPreviousActiveMarker !== marker.title) {
                                        // If there is mapInfoWindow and previousActiveMarker is not the same as current marker
                                        // Clicking different marker - close previous info window and open new
                                        _this.mapInfoWindow.close();
                                        _this.mapInfoWindow = null;
                                        _this.mapInfoWindow = new google.maps.InfoWindow({
                                            content: infoWindowContent,
                                        });
                                        _this.mapInfoWindow.open({
                                            anchor: marker,
                                            map: _this.googleMap,
                                        });
                                        _this.mapPreviousActiveMarker = marker.title;
                                        // Set previousActiveMarker to null on info window close by clicking x button
                                        google.maps.event.addListener(_this.mapInfoWindow, 'closeclick', function () { return _this.mapPreviousActiveMarker = null; });
                                    }
                                    else {
                                        // If no previousActiveMarker and no info window
                                        // First time clicking on marker - open info window
                                        _this.mapInfoWindow = new google.maps.InfoWindow({
                                            content: infoWindowContent,
                                        });
                                        _this.mapInfoWindow.open({
                                            anchor: marker,
                                            map: _this.googleMap,
                                        });
                                        _this.mapPreviousActiveMarker = marker.title;
                                        // Set previousActiveMarker to null on info window close by clicking x button
                                        google.maps.event.addListener(_this.mapInfoWindow, 'closeclick', function () { return _this.mapPreviousActiveMarker = null; });
                                    }
                                });
                                // Add marker to marker array
                                _this.mapMarkers.push(marker);
                            });
                        });
                        this.googleMap.maxDefaultZoom = 15;
                        this.googleMap.fitBounds(bounds); // Fit map to bound all markers
                        google.maps.event.addListenerOnce(this.googleMap, "bounds_changed", function () {
                            this.setZoom(Math.min(this.getZoom(), this.maxDefaultZoom));
                        });
                        this.markerCluster = new MarkerClusterer({
                            map: this.googleMap,
                            markers: this.mapMarkers,
                            renderer: this.markerClusterRenderer,
                            algorithmOptions: { maxZoom: 13 }
                        });
                        google.maps.event.addListenerOnce(this.markerCluster, 'clusteringend', function () {
                            _this.pageOverlay.classList.remove('visible');
                            _this.pageLoader.classList.remove('active');
                            _this.resultsContainer.classList.remove('loading');
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    AllLocationsMap.prototype.loadMarkersApiData = function (loadAll, countryID) {
        var _this = this;
        // Load markers based on country id
        this.pageOverlay.classList.add('visible');
        this.pageLoader.classList.add('active');
        countryID = countryID ? this.activeCountry['id'] : null;
        var options = {
            method: 'POST',
            body: JSON.stringify({ countryId: countryID, loc_type: this.appliedSearchFilter['loc_type'] })
        };
        fetch(this.wordpressApiLink, options)
            .then(function (response) { return response.json(); })
            .then(function (response) {
            _this.searchResults = response;
        })
            .catch(function (error) {
            console.error('Fetch error:', error);
        })
            .finally(function () {
            if (loadAll) {
                _this.setAllCountryMapPosition().then(function (r) { });
            }
        });
    };
    AllLocationsMap.prototype.loadApiResults = function () {
        var _this = this;
        // Load results from api based on applied filters
        this.body.classList.add('no-scroll');
        this.pageOverlay.classList.add('visible');
        this.pageLoader.classList.add('active');
        this.resultsContainer.classList.add('loading');
        this.mapBlock.scrollIntoView({ behavior: "smooth" });
        var options = {
            method: 'POST',
            body: JSON.stringify(this.appliedSearchFilter)
        };
        fetch(this.wordpressApiLink, options)
            .then(function (response) { return response.json(); })
            .then(function (response) {
            _this.searchResults = response;
            _this.setDomElements();
        })
            .catch(function (error) {
            console.error('Fetch error:', error);
        })
            .finally(function () {
            _this.body.classList.remove('no-scroll');
        });
    };
    AllLocationsMap.prototype.setDomElements = function () {
        var _this = this;
        var hash = window.location.hash;
        // Set dom elements based on search results
        if (this.searchResults['status'] === 'success') {
            this.resultsContainer.innerHTML = ''; // clear out old results
            this.countrySelect.innerHTML = ''; // clear select elements
            this.countryChoicesJsSelect = window.choicesJsElements[this.mapBlockId]; // set ChoicesJs select element
            var choicesJsOptions_1 = []; // List of choicesJs select options
            var showAllTranslation = this.countrySelect.dataset.showAll; // Show all text translation
            var selectOptionHtml = '<option value="all" selected>' + showAllTranslation + '</option>'; // Show all option
            this.countrySelect.insertAdjacentHTML('beforeend', selectOptionHtml); // Add show all option
            // Country list item html code
            var html = '<div class="country-list-item all" data-country-name="all" data-country-id="all">';
            html += '<div class="item-header"><h4 class="color-reset">' + showAllTranslation + '</h4>';
            html += '<button class="item-toggle"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" width="20" height="20" fill="none"><path stroke="currentColor" stroke-miterlimit="10" stroke-width="1.2" d="m2 7.475 6.178 6.287a2.558 2.558 0 0 0 3.644 0L18 7.475"/></svg></button>';
            html += '</div><div class="country-items"></div></div>';
            // Add to country list
            this.resultsContainer.insertAdjacentHTML('beforeend', html);
            this.searchResults.data.forEach(function (country, index) {
                var countryId = country['countryId'];
                var countryName = country['country'];
                var countryItemCount = country['itemCount'];
                // Add to choicesJs option array
                if (!hash || hash === '') {
                    choicesJsOptions_1.push({ value: countryId, label: countryName, selected: false });
                }
                else if (hash && hash.includes(_this.mapBlockId)) {
                    var cleanedHash = decodeURIComponent(hash.replace("#".concat(_this.mapBlockId, "-"), ''));
                    var _a = cleanedHash.split('-'), locationType = _a[0], locationCountry = _a[1];
                    if (parseInt(locationCountry) === countryId) {
                        choicesJsOptions_1.push({ value: countryId, label: countryName, selected: true });
                    }
                    else {
                        choicesJsOptions_1.push({ value: countryId, label: countryName, selected: false });
                    }
                }
                // select option html code
                var selectOptionHtml = '<option value="' + countryId + '">' + countryName + '</option>';
                // add to select options list
                _this.countrySelect.insertAdjacentHTML('beforeend', selectOptionHtml);
                // Country list item html code
                var html = '<div class="country-list-item" data-country-name="' + countryName + '" data-item-count="' + countryItemCount + '" data-country-id="' + countryId + '">';
                html += '<div class="item-header"><h4 class="color-reset">' + country['country'] + '</h4>';
                html += '<button class="item-toggle"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" width="20" height="20" fill="none"><path stroke="currentColor" stroke-miterlimit="10" stroke-width="1.2" d="m2 7.475 6.178 6.287a2.558 2.558 0 0 0 3.644 0L18 7.475"/></svg></button>';
                html += '</div><div class="country-items"></div></div>';
                // Add to country list
                _this.resultsContainer.insertAdjacentHTML('beforeend', html);
            });
            // if page doesn't have hash or hash is empty - reset location type and country
            if (!hash || hash === '') {
                choicesJsOptions_1.push({ value: 'all', label: showAllTranslation, selected: true });
            }
            else if (hash && hash.includes(this.mapBlockId)) {
                choicesJsOptions_1.push({ value: 'all', label: showAllTranslation, selected: false });
            }
            this.countryChoicesJsSelect.setChoices(choicesJsOptions_1, 'value', 'label', true); // Set ChoicesJs options
            this.mapCountriesData = []; // Clear out map countries data
            // Set new countries list
            this.countries = this.resultsContainer.querySelectorAll('.country-list-item');
            this.countryListToggleListener(true); // Reset country list listeners
        }
        else {
            // Set list results as - no results found
            this.resultsContainer.innerHTML = this.searchResults.data.data;
        }
        // if page doesn't have hash or hash is empty - reset location type and country
        if (!hash || hash === '') {
            var showAllToggle = this.mapBlock.querySelector('.country-list-item.all');
            this.activeCountry = { name: 'all', id: 'all' };
            showAllToggle.classList.add('active');
            this.loadMarkersApiData(true); // Load all markers - sets bound to fit all
        }
        else if (hash && hash.includes(this.mapBlockId)) {
            var cleanedHash = decodeURIComponent(hash.replace("#".concat(this.mapBlockId, "-"), ''));
            var _a = cleanedHash.split('-'), locationType = _a[0], locationCountry_1 = _a[1];
            this.activeLocationType = locationType;
            // Set active country based on url hash
            this.countrySelect.querySelectorAll('option').forEach(function (countryOption) {
                if (countryOption.value === locationCountry_1) {
                    countryOption.selected = true;
                }
                else {
                    countryOption.selected = false;
                }
            });
            this.resultsContainer.querySelectorAll('.country-list-item').forEach(function (countryListItem) {
                if (countryListItem.dataset.countryId === locationCountry_1) {
                    _this.activeCountry = { name: countryListItem.dataset.countryName, id: locationCountry_1 };
                    countryListItem.classList.add('active');
                }
                else {
                    countryListItem.classList.remove('active');
                }
            });
            this.setClickedCountryMapPosition().then(function (r) { });
            this.loadMarkersApiData(false); // Loads all, but sets bound to fit specific country
        }
    };
    return AllLocationsMap;
}());
var allLocationsMapBlocks = document.querySelectorAll('[data-all-locations-map-block]');
allLocationsMapBlocks.forEach(function (allLocationsMapBlock) {
    new AllLocationsMap(allLocationsMapBlock);
});
